export default __webpack_public_path__ + "static/rJWrlnMk-d25eed0bc2319da03f4527b3b69bfd9e.svg";